import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import { isNumeric, isUuid, createCustomPropType } from '../../../../../js/app/react/validators';
import { EDIT_ACCOUNT, DELETE_ACCOUNT } from './AccountsOverviewMenuOptions';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';
import { WORKFLOW_ID as EMERGENCY_FUND_WORKFLOW_ID } from '../../../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import Button from '../../../../CommonComponents/Button';

const AccountsOverviewView = ({
  clientId,
  workflowId,
  accountsList,
  graphAccounts,
  onMenuOptionClicked,
  onAddAccount,
  filterDeletedDebtAccounts,
  noDeletedAccounts,
  isEmptyState,
}) => {
  const title =
    workflowId === EMERGENCY_FUND_WORKFLOW_ID
      ? 'Do you currently have any debts?'
      : 'Which debts do you currently have?';

  return (
    <div className="AccountsOverviewView">
      <h2 className="h2">{title}</h2>
      <div className="adv-workflow-crud-widget">
        {isEmptyState ? (
          <div className="adv-workflow-crud-empty">
            <div className="adv-workflow-crud-empty-add">
              <Button
                className="adv-workflow-crud-empty-add-button"
                type="button"
                onClick={onAddAccount(workflowId, clientId)}
              >
                <i className="adv-workflow-crud-empty-add-button-i">+</i>
                <br />
                Add a new debt
              </Button>
            </div>
          </div>
        ) : (
          <div className="adv-workflow-crud-populated">
            <ul className="adv-workflow-crud-populated-ul">
              {/* eslint-disable-next-line */}
              {accountsList.map(({ id, label, value, isLink }) => (
                <li className="adv-workflow-crud-populated-li" key={id}>
                  <div className="adv-workflow-crud-populated-name-2">{label}</div>
                  <div className="adv-workflow-crud-populated-value-2">{value}</div>
                  <div className="adv-workflow-crud-populated-actions">
                    <button
                      type="button"
                      className="adv-workflow-crud-populated-action"
                      aria-label="edit debt"
                      onClick={onMenuOptionClicked(
                        workflowId,
                        clientId,
                        id,
                        graphAccounts,
                      )(EDIT_ACCOUNT)}
                    >
                      <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                    </button>
                    <button
                      type="button"
                      className="adv-workflow-crud-populated-action"
                      aria-label="remove debt"
                      onClick={onMenuOptionClicked(
                        workflowId,
                        clientId,
                        id,
                        graphAccounts,
                      )(DELETE_ACCOUNT)}
                    >
                      <i className="adv-workflow-crud-populated-action-i fa fa-trash-o" />
                    </button>
                    {isLink ? (
                      <div className="adv-workflow-crud-populated-action">
                        <i className="adv-workflow-crud-populated-action-i fa fa-link" />
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="adv-workflow-crud-populated-action"
                        aria-label="remove debt"
                        onClick={onMenuOptionClicked(
                          workflowId,
                          clientId,
                          id,
                          graphAccounts,
                        )(DELETE_ACCOUNT)}
                      >
                        <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                      </button>
                    )}
                  </div>
                </li>
              ))}
            </ul>
            <div className="adv-workflow-crud-populated-add">
              <button
                className="adv-workflow-crud-populated-add-button"
                onClick={onAddAccount(workflowId, clientId)}
                type="button"
              >
                <i className="adv-workflow-crud-populated-add-button-i">+</i>
                Add a new debt
              </button>
            </div>
          </div>
        )}
      </div>

      <Navigation
        nextIterators={[]}
        dirtyGraphNodes={[]}
        workflowId={workflowId}
        backendKey={BACKEND_KEY}
        doNotSave={noDeletedAccounts}
        onPostProcess={filterDeletedDebtAccounts}
      />
    </div>
  );
};

AccountsOverviewView.defaultProps = {};

AccountsOverviewView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: PropTypes.string.isRequired,
  accountsList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: createCustomPropType(isUuid).isRequired,
      isSelected: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  graphAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onMenuOptionClicked: PropTypes.func.isRequired,
  onAddAccount: PropTypes.func.isRequired,
  filterDeletedDebtAccounts: PropTypes.func.isRequired,
  noDeletedAccounts: PropTypes.bool.isRequired,
  isEmptyState: PropTypes.bool.isRequired,
};

export default AccountsOverviewView;
